import { BasicRoute, BasicRouteProps } from './BasicRoute';

interface PublicRouteProps
    extends Omit<
        BasicRouteProps,
        'condition' | 'loading' | 'redirectTo' | 'users'
    > {}

export const PublicRoute = ({ ...routeProps }: PublicRouteProps) => {
    return (
        <BasicRoute
            {...routeProps}
            condition={true}
            redirectTo="/"
            users={['notLogged']}
        />
    );
};
